import * as React from "react";
import type { ReactNode } from "react";

import { StyledFooter } from "./Footer.styles";

interface FooterProps {
    start?: ReactNode;
    end?: ReactNode;
    children?: ReactNode;
}

export const Footer = (props: FooterProps) => {
    const showElement = Boolean(props.start || props.children || props.end);
    return showElement ? (
        <StyledFooter>
            {props.start && <div>{props.start}</div>}
            {props.children && <div>{props.children}</div>}
            {props.end && <div>{props.end}</div>}
        </StyledFooter>
    ) : null;
};
